module.exports = __webpack_public_path__ + "static/media/DistractionTechniques.55d193d3.mp3";